export default __webpack_public_path__ + "static/pipeline-12d17037829d1a5f845b35fe1d2f9baa.webp";